export default __webpack_public_path__ + "static/media/read.b42657aa.png";